<template>
  <el-dialog
  :visible="visible"
  :fullscreen="true"
  :close-on-press-escape="false"
  :show-close="false"
  :append-to-body="true"
  center
  v-loading.fullscreen.lock="invoiceLoading"
  @open="open">
  <span slot="title" class="dialog-header">
    <span  class="title" >{{title}}</span>
  </span>
  <el-row justify="center">
    <el-col class="formContainer" :xs="24" :sm="24" :md="18" :lg="18" :xl="18">
      <el-form label-position="top" label-width="100px" :rules="rules" ref="invoiceForm" :model="invoice">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item :label="$t('invoices.customer')" prop="customer">
                <SelectCustomerComponent :active="true" :customer="invoice.customer" @selected="selectCustomer"></SelectCustomerComponent>
              </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
              <el-form-item :label="$t('invoices.invoiceNumber')">
                <el-input :value="invoice.invNumber" :disabled="true"></el-input>
              </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
              <el-form-item :label="$t('invoices.salesOrderNumber')" v-if="invoice.salesOrders!=null && invoice.salesOrders.length > 0">
                <el-input :value="salesOrdersNumber" :disabled="true"></el-input>
              </el-form-item>
              <el-form-item :label="$t('invoices.purchaseOrderNumber')" v-if="invoice.purchaseOrder!=null && invoice.purchaseOrder.poNumber!=null">
                <el-input :value="invoice.purchaseOrder.poNumber" :disabled="true"></el-input>
              </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" v-if="invoice.customer" class="animated fadeIn">
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-row v-if="invoice.customer.type==1">
              <el-form-item :label="$t('invoices.billedTo')">
                <el-select :value="invoice.billingContact" @change="setBillingContact" placeholder="Select" value-key="id">
                  <el-option
                    v-for="c in activeCustomerContacts"
                    :key="c.id"
                    :label="getName(c)"
                    :value="c">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-row>
            <el-row v-if="invoice.billingAddress">
              <DefaultAddressCard :address="invoice.billingAddress"  :adresseTypeName="billingAddressName"></DefaultAddressCard>
            </el-row>
            <el-row v-else>
              <div>
                <span v-if="invoice.customer.type!=1"><strong>{{ $t('invoices.billedTo') }} :</strong></span> {{$t('invoices.noBilledAddress')}}
              </div>
            </el-row>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-row v-if="invoice.customer.type==1">
              <el-form-item :label="$t('invoices.deliveredTo')">
                <el-select :value="invoice.shippingContact" @change="setShippingContact" placeholder="Select" value-key="id">
                  <el-option
                    v-for="c in activeCustomerContacts"
                    :key="c.id"
                    :label="getName(c)"
                    :value="c">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-row>
            <el-row v-if="invoice.shippingAddress">
                <DefaultAddressCard :address="invoice.shippingAddress" :adresseTypeName="$t('invoices.shippingAddress')"></DefaultAddressCard>
            </el-row>
            <el-row v-else>
              <div>
                <span v-if="invoice.customer.type!=1"><strong>{{ $t('invoices.deliveredTo') }} :</strong></span> {{ $t('invoices.noShippingAddress') }}
              </div>
            </el-row>
          </el-col>
        </el-row>
        <el-divider></el-divider>
        <el-row :gutter="20">
          <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
              <el-form-item :label="$t('invoices.invoiceDate')" prop="date" style="width:100%">
                <el-date-picker v-model="invoiceDate" type="date" :placeholder="$t('common.selectDateInstruction')"></el-date-picker>
              </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
            <el-form-item :label="$t('clients.terms')">
              <el-select v-model="term" :placeholder="$t('clients.terms')" value-key="id">
               <el-option
                 v-for="t in terms"
                 :key="t.id"
                 :label="$t('invoices.terms.'+t.code)"
                 :value="t">
               </el-option>
             </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
              <el-form-item :label="$t('invoices.dueDate')" prop="dueDate">
                <el-date-picker v-model="dueDate" type="date" :placeholder="$t('common.selectDateInstruction')" :disabled="term==null || (term!=null && term.value!=null)"></el-date-picker>
              </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
            <el-form-item :label="$t('invoices.salesRep')" prop="rep">
              <el-select v-model="salesRepModel" :placeholder="$t('common.select.placeholder')" value-key="id">
                  <el-option
                    v-for="user in filterUserWithRoleRep"
                    :key="user.id"
                    :label="user.firstName + ' ' + user.lastName"
                    :value="user">
                  </el-option>
                </el-select>
              </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
            <el-form-item :label="$t('invoices.reference')" >
              <el-input v-model="invoiceNumberReference"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
            <el-form-item :label="$t('invoices.currency')" >
              <el-select v-model="currencyModel" :placeholder="$t('common.select.placeholder')" value-key="id">
                  <el-option
                    v-for="currency in currencies"
                    :key="currency.id"
                    :label="currency.code"
                    :value="currency">
                  </el-option>
                </el-select>
              </el-form-item>
          </el-col>
        </el-row>
        <h3>{{ $t('invoices.invoiceDetail') }}</h3>
        <el-row :gutter="20" class="sticky">
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item :label="$t('invoices.productSelectionInstruction')">
                <el-autocomplete class="inline-input" :disabled="invoice.customer==null" value-key="item_name" v-model="selectedProduct" style="width:100%;" :fetch-suggestions="querySearch" :placeholder="$t('invoices.selectProduct')" @select="addItemLineItem">
                  <template slot-scope="{ item }">
                    <ItemTemplate :product="item" :showQty="false" :volume="item.volume" :format="item.format"></ItemTemplate>
                  </template>
                </el-autocomplete>
              </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <div class="mb-10" style="height:30px;">
            <div v-if="selectedProducts.length > 0">
            <span class="mr-10 fs-14">
              {{$t('invoices.products')}} <i class="el-icon-arrow-right"></i> {{$t('invoices.selected')}}
            </span>
            <span class="bg-accent-lighter b-rad-18 p-8 fs-14">
              {{selectedProducts.length}}
            </span>
            <el-dropdown
              size="small"
              split-button
              type="primary"
              class="ml-20">
              Actions
              <el-dropdown-menu slot="dropdown">
               <el-dropdown-item @click.native="handleRemoveLines"><i class=""></i>{{$t('invoices.removeProduct')}}</el-dropdown-item>
               <el-dropdown-item @click.native="handleaddRebates"><i class=""></i>{{$t('invoices.applyRebates')}}</el-dropdown-item>
               <el-dropdown-item @click.native="handleRemoveRebates"><i class=""></i>{{$t('invoices.removeRebates')}}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
        </el-row>
        <el-table :data="invoice.lines" style="width: 100%"  v-loading="invoiceItemsLoading" @selection-change="handleSelectionChange">
          <span slot="empty">{{$t('invoices.noProductSelected')}}</span>
          <el-table-column
            type="selection"
            width="55">
          </el-table-column>
          <el-table-column
            :label="productLabel">
            <template slot-scope="scope">
              <SalesProductDefinition
                :product="scope.row.product"
                :inventory="scope.row.inventory"
                :vintage="getVintage(scope.row)"
                :item="scope.row.item"
                :showDetailProduct="false"/>
              <!-- <el-popover placement="top" trigger="hover" >
                <span style="break-word:word-break;">{{scope.row.product.name}}</span><br>
                <span v-if="scope.row.product.provider">
                  <span class="fs-14 secondary-text">{{getProviderName(scope.row.product.provider, invoice.purchase_order!=null && invoice.purchase_order.po_number!=null)}}</span><br>
                </span>
                <span v-if="scope.row.reference"><span class="fs-14 secondary-text">{{$t('invoices.lines.reference_code')}} {{scope.row.reference}}</span><br></span>
                <span class="fs-14 secondary-text">SKU : {{scope.row.product.sku}}</span><br>
                <UnitFormatVolumeLabel v-if="scope.row.product.type == 1" :unit="scope.row.product.unit" :uvc="scope.row.product.uvc" :format="scope.row.product.format" :volume="scope.row.product.volume"></UnitFormatVolumeLabel><br>

                <div slot="reference" class="mt-10">
                  <i class="mdi mdi-barcode-scan" :class="{'mdi-barcode-scan' : scope.row.product.type==1, 'mdi-cards-variant' : scope.row.product.type==0}" style="font-size:18px;margin-right:5px;color: grey;"></i>
                  <span style="break-word:word-break;">{{scope.row.product.name}}</span> <span class="fs-14 secondary-text" v-if="scope.row.product.provider">, {{getProviderName(scope.row.product.provider, invoice.purchase_order!=null && invoice.purchase_order.po_number!=null)}}</span>
                </div>
              </el-popover> -->
              <br>
              <el-input type="textarea" :value="scope.row.description" :autosize="{ minRows: 1, maxRows: 1 }" placeholder="Ajouter une description" class="mt-5" @input="v => setDescription(scope.row.uuid, v)"></el-input>
            </template>
          </el-table-column>
          <el-table-column :label="quantityLabel" style="line-height:20px;"  align="center" width="120">
            <template slot-scope="scope">
              <el-form-item>
                <unitQuantities
                  @change="v => setQtyOrdered(scope.row.uuid, v)"
                  :showUnitControl="scope.row.type==1"
                  :default="scope.row.qty"
                  :product_unit="scope.row.product.unit"
                  :product_uvc="scope.row.product.uvc"
                  :default_unit="2" />
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column :label="$t('invoices.price')" v-if="$can('manage', 'SalesOrders')" align="center">
            <template slot-scope="scope" class="p-10" >
              <!-- <el-form-item> -->

                <span v-if="scope.row.prices.length>1">{{$n(unitPrice(scope.row), 'currency')}}<br></span>
                <span v-for="(price, index) in scope.row.prices" :key="index" style="padding:0px;">
                  <span class="fs-14 secondary-text" v-if="!price.editState">
                    <span v-if="scope.row.prices.length>1">{{$t("sales_orders.price_label."+price.label)}} : </span>
                    {{price.price}}
                    <el-button  size="mini" v-if="$can('manage', 'Invoices') && (price.takeAccountIntoCalculation==null || price.takeAccountIntoCalculation==true)" type="text" @click="editItemPrice({uuid : scope.row.uuid, action:'show', index});"><i class="el-icon-edit"></i></el-button>
                  </span>
                  <el-input-number
                    :ref="'price_'+index+'_'+scope.row.uuid"
                    @keyup.enter.native="editItemPrice({uuid : scope.row.uuid, action:'hide', index});"
                    @change="v=>{setPrice(scope.row.uuid, v, index)}"
                    @blur="editItemPrice({uuid : scope.row.uuid, action:'hide', index})"
                    :value="price.price"
                    v-if="price.editState"
                    :controls="false"
                    size="mini"
                  ></el-input-number>
                  <br v-if="(index-1) < scope.row.prices.length"/>
                </span>

                <TaxesPopover  :usedTaxes="scope.row.productTaxes" @applyTaxes="v=>setTaxes(v,scope.row.uuid)"></TaxesPopover>
              <!-- </el-form-item> -->
            </template>
          </el-table-column>
          <el-table-column :label="$t('invoices.rebate')" width="150" align="center" >
            <template slot-scope="scope">

              <div >
                <el-link :underline="false" type="primary" slot="reference" @click="openRebateCreditDrawer(scope.row)">
                  <i class="el-icon-circle-plus" v-if="scope.row.discount == null || scope.row.discount.amount==null"></i>
                  <span v-if="scope.row.discount != null && scope.row.discount.type==1">{{scope.row.discount.value}}%</span>
                  <span v-else>
                    <span v-if="scope.row.discount == null || scope.row.discount.amount==null"></span>
                    <div v-else>

                      <span v-if="scope.row.discount != null && scope.row.discount.netType=='UNIT'">{{scope.row.discount.value && scope.row.discount.amount}}$ / b.</span>
                      <span v-else>{{scope.row.discount.value}}$</span>
                    </div>
                  </span>
                </el-link>
              </div>

            </template>
          </el-table-column>
          <el-table-column :label="$t('invoices.gl')" v-if="$can('manage', 'SalesOrders')" align="center">
            <template slot-scope="scope" class="p-10">
              <el-select :value="scope.row.account" @change=" v => setGlAccount(scope.row.uuid, v)" value-key="id">
                <el-option
                  v-for="item in getGlAccountsByCompanyId[getCurrentPortausCompany.id]"
                  :key="item.id"
                  :label="item.name + '(' + item.number + ')'"
                  :value="item">
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column :label="$t('invoices.subTotal')" width="150" align="center">
            <template slot-scope="scope">
              <el-form-item>
                <span class="fs-14" >{{$n(scope.row.subTotalBrut,'currency', currency)}}</span>
                <span v-if="scope.row.discount!=null && scope.row.discount.amount!=null"><br>({{$n(scope.row.discount.amount,'currency',currency)}}) </span>
              </el-form-item>
            </template>
          </el-table-column>

          <el-table-column width="50">
            <template slot-scope="scope">
              <el-form-item>
                <el-link style="color:red;" icon="el-icon-close" :underline="false" @click="removeItemLine(scope.$index)"></el-link>
              </el-form-item>
            </template>
          </el-table-column>
        </el-table>
        <table style="width:100%;margin-top:20px;">
            <tr>
              <td class="fs-14 secondary-text" style="text-align:right;">{{$t('invoices.subTotalField')}}</td>
              <td class="fs-14 secondary-text" style="text-align:right;width:150px;">{{$n(invoice.subTotal,'currency',currency)}}</td>
            </tr>
            <tr>
              <td class="fs-14 secondary-text" style="text-align:right;"><span v-if="invoice.discount != null">{{$t('invoices.rebateField')}}</span></td>
              <td class="fs-14 secondary-text" style="text-align:right;width:150px;">
                <el-link :underline="false" type="primary" slot="reference" @click="openGlobalRebateCreditDrawer(invoice.discount)">
                  <span v-if="invoice.discount==null">{{$t('invoices.rebate')}} <i class="el-icon-circle-plus" ></i></span>
                  <div v-else>
                    <span v-if="invoice.discount.type==1">({{invoice.discount.value}}%) ({{$n(invoice.discount.amount, 'currency')}})</span>
                    <span v-else>
                      <span v-if="invoice.discount.netType=='TOTAL'">({{$n(invoice.discount.value, 'currency')}})</span>
                    </span>
                  </div>
                </el-link>
              </td>
            </tr>
            <tr v-for="(tax, index) in invoice.taxes" :key="index">
              <td class="fs-14 secondary-text" style="text-align:right;">{{tax.name || tax.label}} ({{tax.number||tax.taxNumber}}) : </td>
              <td class="fs-14 secondary-text" style="text-align:right;width:150px;">{{$n(tax.total,'currency',currency)}}</td>
            </tr>
            <tr>
              <td class="fs-14 secondary-text" style="text-align:right;">{{ $t('invoices.totalField') }}</td>
              <td class="fs-14 secondary-text" style="text-align:right;width:150px;">{{$n(invoice.total,'currency',currency)}}</td>
            </tr>
            <tr v-if="creditNotes_credit>0">
              <td class="fs-14 secondary-text" style="text-align:right;">{{$t('invoices.creditsApplied')}}</td>
              <td class="fs-14 secondary-text" style="text-align:right;width:150px;">{{$n(creditNotes_credit,'currency',currency)}}</td>
            </tr>
            <tr v-if="invoice.balance != null && invoice.balance.paid != null">
              <td class="fs-14 secondary-text" style="text-align:right;">{{$t('invoices.paidAmount')}} </td>
              <td class="fs-14 secondary-text" style="text-align:right;width:150px;">{{$n(invoice.balance.paid,'currency',currency)}}</td>
            </tr>
            <tr>
              <td class="fs-14 secondary-text" style="text-align:right;">{{ $t('invoices.outstandingAmountField') }}</td>
              <td class="fs-14 secondary-text" style="text-align:right;width:150px;">{{$n(balanceToPay,'currency',currency)}}</td>
            </tr>

        </table>

        <el-row>
          <el-card shadow="never" style="margin:20px;">
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" style="border-right:1px solid #EBEEF5;margin-bottom:15px;">
              <el-row :gutter="20" v-if="!editionMode">
                <el-col>
                  <span class="fs-14" v-if="creditNotes.length>0"><i class="mdi mdi-square-inc-cash" /> {{ $t('invoices.availableCredits') }} {{$n(getCreditBalance(creditNotes)-creditNotes_credit, 'currency',currency)}}
                    <el-button type="text" @click="openCreditNoteDrawer">{{$t('invoices.applyNow')}}</el-button >
                  </span>
                </el-col>
              </el-row>
              <el-row  :gutter="20">
                <el-col>
                  <el-form-item :label="$t('invoices.paymentOptions')">
                    <el-checkbox-group v-model="paymentOptions" style="display:grid;" :disabled="invoice.total==0">
      								<el-checkbox v-for="t in onlinePaymentMethods" :label="t.id" :key="t.id" :value="t">{{$t('invoices.'+t.code)}}</el-checkbox>
      							</el-checkbox-group>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" style="padding-left:20px;">
              <el-row>
                <el-col>
                  <el-form-item :label="$t('invoices.customerNotes')">
                      <quill-editor v-model="notes" style="border:1px solid #EBEEF5"
                				ref="noteEditor"
                				:options="editorOptions">
                			</quill-editor>
                      <p style="margin-top:0px;"><i><span style="font-size:0.8em;color:#909399">{{$t('invoices.noteVisibleOnInvoice')}}</span></i></p>
                    </el-form-item>
                </el-col>
              </el-row>
              <el-row v-if="canShowTierceOutstandingAmount">
                <el-col>
                  <el-checkbox v-model="show_tierce_agency_outstanding">{{ $t('invoices.showSAQOutstandingAmount') }}</el-checkbox>
                </el-col>
              </el-row>
              <el-row v-if="canShowDetailedPrices">
                <el-col>
                  <el-checkbox v-model="detailedPrices">{{ $t('invoices.showDetailedPrices') }}</el-checkbox>
                </el-col>
              </el-row>
            </el-col>
          </el-card>
        </el-row>
      </el-form>
    </el-col>
  </el-row>
  <span slot="footer" class="dialog-footer card-shadow--large">
    <el-button @click="closeDialog" :disabled="invoiceItemsLoading">{{$t('common.Cancel')}}</el-button>
    <el-button type="primary" @click="save('save')" v-if="canSaveDraft" :disabled="invoiceItemsLoading || edition">{{$t('buttons.saveDraft')}}</el-button>
    <el-button type="primary" @click="save('send')" v-if="canSaveAndSend" :disabled="invoiceItemsLoading  || edition">{{$t('buttons.saveAndSend')}}</el-button>
    <el-button type="primary" @click="save('save')" v-if="!canSaveDraft" :disabled="invoiceItemsLoading  || edition">{{$t('buttons.Save')}}</el-button>
  </span>
  <sendInvoiceDialog v-if="invoice.customer && invoice.customer.language" :visible="sendInvoiceDialog" :invoice="createdInvoice||editInvoice" :contacts="activeCustomerContacts" :language="invoice.customer.language.code" @close="closeSendInvoiceDialog" @sent="invoiceSent"></sendInvoiceDialog>
  <RebateDrawer :visible="rebateDrawerVisible" :showNetType="showNetType" :rebateToEdit="rebateToEdit" :itemUuid="rebateOnItemUuid" @close="closeRebateCreditDrawer" @update="v=> handleChangeDiscount({discount:v.rebate,uuid:v.itemUuid})"> </RebateDrawer>
  <CreditNoteApplicationDrawer :visible="creditApplicationDrawerVisible" :creditNotes="creditNotes" :editCreditNotes="invoice.creditNotes" :balanceToPay="outstanding" :invoice="invoice" @close="closeCreditNoteDrawer" @apply="applyCreditNotes"></CreditNoteApplicationDrawer>
  <!-- <RebateCreditDrawer :visible="rebateCreditDrawerVisible" :rebateToEdit="rebateToEdit" :itemUuid="rebateOnItemUuid" @close="closeRebateCreditDrawer" @update="v=> setDiscount({discount:v.rebate,uuid:v.itemUuid})"> </RebateCreditDrawer> -->
  </el-dialog>
</template>
<script>
import axios from "axios"
import moment from 'moment-timezone'
import { mapActions, mapState, mapGetters } from 'vuex';
import productAPI from '@/services/API/product.js'
import DefaultAddressCard from '@/components/address/Default-Address-Card'
import ItemTemplate from '@/components/product/item-template'
import unitQuantities from '@/components/product/unit-quantities';
import sendInvoiceDialog from '@/components/invoice/send-invoice-dialog.vue'
import CreditNoteApplicationDrawer from '@/components/creditNote/credit-note-application-drawer'
import ContactUtils from '@/utils/contact-utils.js'
import RebateDrawer from '@/components/sales-order-rebate-drawer';
import CustomerSelectItem from '@/components/customer-select-item'
import TaxesPopover from '@/components/taxes-popover'
import UnitFormatVolumeLabel from '@/components/product/unitFormatVolumeLabel'
import SalesProductDefinition from '@/components/salesOrder/sales-product-definition'
import SelectCustomerComponent from '@/components/customer/select-customer-autocomplete'

export default {
  name: 'InvoiceEditor',
	props: {
		visible : Boolean,
    editInvoice : {
        type : Object,
        default : null
    },
    customerId : {
      type : String,
      default : null,
    }
	},
  data() {
    return {
      selectedProduct : null,
      fileList : [],
      rules : {
        dueDate : [
  	  		 	{ required: true, message: "La date d'échéance est obligatoire", trigger: 'blur' }
  	  		],
      },
      edition : false,
      sendInvoiceDialog:false,
      editorOptions: {
				theme: 'bubble',
        modules: {
					toolbar: [
						['bold', 'italic', 'underline', 'strike']
					]
				}
			},
      createdInvoice : null,
      creditApplicationDrawerVisible : false,
      rebateDrawerVisible : false,
      rebateOnItemUuid : null,
      showNetType: false,
      rebateToEdit :null,
      searchTimeOut : null,
      selectedProducts: [],
      multipleLineRebate: false,
    };
  },components: {
    DefaultAddressCard,
    ItemTemplate,
    unitQuantities,
    sendInvoiceDialog,
    CreditNoteApplicationDrawer,
    RebateDrawer,
    CustomerSelectItem,
    TaxesPopover,
    UnitFormatVolumeLabel,
    SalesProductDefinition,
    SelectCustomerComponent,
  },
	methods: {
    getVintage (line) {
      return _.get(line, 'item.extraInfo.vintage');
    },
    handleChangeDiscount ({ discount, uuid}) {
      if (this.multipleLineRebate === true) {
        this.applyDiscount({discount, selectedLines: this.selectedProducts });
      } else {
        this.setDiscount({ discount, uuid });
      }
    },
    handleRemoveLines () {
      this.$confirm('Êtes vous certain de vouloir supprimer les produits de la facture?', 'Attention', {
          confirmButtonText: 'Oui',
          cancelButtonText: 'Annuler',
          type: 'warning'
        }).then(() => {
          this.removeLines(this.selectedProducts);
        }).catch((err) => {
          // Do nothing
        })
    },
    handleaddRebates () {
     this.multipleLineRebate = true;
     this.openRebateCreditDrawer();
    },
    handleRemoveRebates () {
      this.removeRebates(this.selectedProducts);
    },
    handleSelectionChange (val) {
      this.selectedProducts = val;
    },
    setTaxes(productTaxes, uuid){
        this.setItemLineProp({uuid, itemProp:{productTaxes}});
    },
    applyCreditNotes(creditNotes){
      this.applyCreditNotes(creditNotes);
    },
    unitPrice(item){
      let price = 0.00;
      _.forEach(item.prices, p=>{
        price+=p.price;
      })
      return price;
    },
    getProviderName(provider, forceRealName=false){
      if(provider!=null && provider.usual_name!=null && provider.usual_name!='' && !forceRealName){
        return provider.usual_name;
      }else if(provider!=null){
        return provider.name;
      }
    },
    openCreditNoteDrawer(){
      if(this.invoice.total==0){
        this.$message.error("Veuillez sélectionner des produits avant d'appliquer des crédits");
      }else{this.creditApplicationDrawerVisible = true;}

    },
    closeCreditNoteDrawer(){
      this.creditApplicationDrawerVisible = false;
    },
    openGlobalRebateCreditDrawer(discount){
      this.showNetType = false;
      this.rebateOnItemUuid = null;
      this.rebateToEdit = discount;
      this.rebateDrawerVisible=true
    },
    openRebateCreditDrawer(item){
      this.showNetType = true;
      if(_.get(item, 'discount.amount') != null){
        this.rebateToEdit = item.discount;
      }else{
        this.rebateToEdit=null;
      }
      this.rebateOnItemUuid = _.get(item, 'uuid');
      this.rebateDrawerVisible=true
    },
    closeRebateCreditDrawer(){
      this.rebateDrawerVisible = false;
      this.multipleLineRebate = false;
    },
    editItemPrice({uuid , action, index}){

      this.editPrice({uuid, action, index});
      if(action==="show"){
        this.edition = true;

        this.$nextTick(() => this.$refs['price_'+index+'_'+uuid][0].focus())
      }else {
        this.edition = false;
      }


    },
    getName(contact){
      return ContactUtils.getName(contact);
    },
    closeSendInvoiceDialog(){
      this.sendInvoiceDialog=false;
      this.closeDialog();
      this.$emit('created', this.createdInvoice);
      if (this.editionMode) {
        this.$message({
          message: 'La facture a été modifiée avec succès. Numéro de facture : '+this.createdInvoice.invNumber,
          type: 'success'
        });
      } else {
        this.$message({
        message: 'La facture a été créée avec succès. Numéro de facture : '+this.createdInvoice.invNumber,
        type: 'success'
      });
      }
      
    },
    openSendInvoiceDialog(){
      this.sendInvoiceDialog=true;
    },
    getInStockQty(item){
      // console.log("ITEM : ", item);
      if(item.quantities!=null){
        return item.quantities.in_stock;
      }else{
        return "";
      }
    },
    _moment(datetime, format='LL'){
      return moment(datetime).format(format);
    },
    closeDialog(){
      this.$emit('close');
      this.reset();
    },
    open(){
      this.initInvoiceEditor(this.editInvoice);
      this.fetchPaymentMethods();

    },
    querySearch(queryString, cb){
      if (_.trim(queryString) === '') {
        cb([]);
      } else {
        clearTimeout(this.searchTimeOut);
        this.searchTimeOut = setTimeout(() => {
          productAPI.listProductsV2({paging:'no',searchTerms:queryString, active: true})
            .then(products=>{
              cb(products);
            })
        }, 500)
      }


    },
    createFilter(queryString) {
      return (item) => {
        return (item.name.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    setQtyOrdered(uuid,qty){
      this.setItemLineProp({uuid, itemProp:{qty}});
    },
    setGlAccount(uuid,account){
      this.setItemLineProp({uuid, itemProp: { account }});
    },

    setPrice(uuid, price, priceIndex){
      this.setItemLineProp({uuid, itemProp:{price}, priceIndex});
    },
    setDescription(uuid, description){
      this.setItemLineProp({uuid, itemProp:{description}});
    },
    setDiscount({ discount,uuid }){
      if (uuid) {
        this.setItemLineProp({uuid, itemProp:{discount}});
      } else {
        this.setGlobalDiscount(discount);
      }
    },
    handleRemove(file, fileList) {
        // console.log(file, fileList);
    },
    handlePreview(file) {
      // console.log("preview : ", file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(`La limite est 3, vous avez choisi ${files.length} fichiers, soit ${files.length + fileList.length} au total.`);
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`Supprimer le transfert de ${ file.name } ?`);
    },
    invoiceSent(){
      this.$message({
        message: 'La facture a été créée et envoyée avec succès. Numéro de facture : '+this.createdInvoice.invNumber,
        type: 'success'
      });
      this.$emit('created', this.createdInvoice);
      this.$emit('close');
    },
    showInvoiceCreatedMsg(invNumber){
      this.$message({
        message: 'La facture a été créée avec succès. Numéro de facture : ' + invNumber,
        type: 'success'
      });
    },
    save(action){
      // console.log("this.editionMode : ", this.editionMode);
      let saveFunction = !this.editionMode?this.postInvoice:this.putInvoice;
      let sendAfterSaving = action==='send';
      action='save';
      //On valide le form
      this.$refs['invoiceForm'].validate((valid)=>{
        this.validate(action)
          .then(invoiceValid=>{
            if(valid && invoiceValid){
              saveFunction(action)
                .then(result=>{
                  // console.log("result : ", result);
                  if(sendAfterSaving){
                    //On valide si l'envoie de se faire ne ligne ou non
                    if(this.invoice.customer.onlineInvoicingInd === false || this.invoice.customer.online_invoicing_ind === false){
                      this.$confirm(this.$i18n.t('invoices.manual_sending_instruction'), this.$i18n.t('invoices.manual_sending_instruction_title'),{
                                confirmButtonText: 'OK',
                                cancelButtonText: 'Annuler',
                                type: 'warning'
                              }).then(()=>{
                                this.markAs({invoiceId : result.id, statusCode : 'TO_SEND'})
                                .then(invoice=>{
                                  this.$emit(this.editionMode?'updated':'created', invoice);
                                  if(this.editionMode){
                                    this.updateSelectedInvoice(invoice);
                                  }
                                  this.closeDialog();
                                  this.showInvoiceCreatedMsg(result.invNumber);
                                })
                              }).catch(err=>{
                                console.log(err);
                                if(err=='cancel'){
                                  this.$emit('created', result);
                                  this.invalidateList();
                                  this.closeDialog();
                                  this.showInvoiceCreatedMsg(result.invNumber);
                                }else{
                                  this.$notify({
                                      title: 'Erreur',
                                      message: 'Une erreur système est survenue. Veuillez réessayer plus tard.',
                                      type: 'error'
                                    });
                                }

                              })

                    } else {
                      this.createdInvoice=result;
                      
                      this.openSendInvoiceDialog()
                    }


                  }else{
                    if(!this.editionMode){
                      this.$emit('created', result);
                      this.invalidateList();
                      this.showInvoiceCreatedMsg(result.invNumber);
                    }else{
                      this.$emit('updated', result);
                      this.$message({
                        message: 'La facture a été modifiée avec succès.',
                        type: 'success'
                      });
                    }

                    this.closeDialog();
                  }

                }).catch(err=>{
                  console.log(err);
                  this.$notify({
                      title: 'Erreur',
                      message: 'Une erreur système est survenue. Veuillez réessayer plus tard.',
                      type: 'error'
                    });
                })
            }else{
              if(!valid){
                this.$message({
                    message: "Certains champs obligatoires n'ont pas été renseignés.",
                    type: 'warning'
                  });
              }
            }
          })
      });

    },
    ...mapActions('invoiceEditor',['fetchSearchedCustomers','selectCustomer','setBillingContact','setShippingContact','setInvoiceDate','setDueDate','addItemLineItem','setItemLineProp','setTerm','setPaymentMethods','setNotes','initInvoiceEditor', 'postInvoice','putInvoice','validate','reset','removeItemLine','editPrice','setShowTierceAgencyOutstanding','setShowDetailedPrices', 'applyCreditNotes','markAs','setSalesRep','setInvoiceNumberReference', 'setCurrency', 'setGlobalDiscount', 'removeLines',
    'applyDiscount', 'removeRebates']),
    ...mapActions('stockItems',['fetchAllItems','invalidateAllItems']),
    ...mapActions('products',['fetchProducts']),
    ...mapActions('creditNotes',['invalidateList']),
    ...mapActions('invoices',['updateSelectedInvoice']),
    ...mapActions('users',['fetchAdminUsers']),
    ...mapActions('statuses',['fetchInvoiceStatuses']),
    ...mapActions('controlData', ['fetchGLAccounts', 'fetchCurrencies', 'fetchPaymentMethods'])
	},
	computed: {
    canShowDetailedPrices () {
      if (this.invoice != null) {
        let canShow = false;
        _.forEach(this.invoice.lines, l => {
          if (_.size(l.prices) > 1) {
            canShow = true;
          }
        })
        return canShow;
      }
      return false;
    },
    canShowTierceOutstandingAmount () {
      if (this.invoice != null) {
        let canShow = false;
        _.forEach(this.invoice.lines, l => {
          if (_.size(l.prices) > 1) {
            _.forEach(l.prices, p => {
              if (p.takeAccountIntoCalculation === false) {
                canShow = true;
              }
            })
          }
        })
        return canShow;
      }
      return false;
    },
    productLabel () {
      return `${this.$i18n.t('invoices.product')} (${this.nbLines})`;
    },
    quantityLabel () {
      return `${this.$i18n.t('invoices.quantity')} (${this.totalQuantities})`;
    },
    nbLines () {
      return this.invoice.lines.length;
    },
    totalQuantities (){
      let count = 0;
      _.forEach(this.invoice.lines, (l) => {
        count += l.qty;
      })
      return count;
    },
    outstanding(){
      if(this.invoice == null) return 0;
      if(this.invoice.balance == null) return this.invoice.total;
      return this.invoice.balance.outstanding;
    },
    salesOrdersNumber(){
      let str ='';
      _.forEach(this.invoice.salesOrders, (salesOrder, index) => {
        if(index > 0) str += ', ';
        str += salesOrder.soNumber;
      })
      return str;
    },
    currency(){
      return this.invoice!=null && this.invoice.currency!=null ? this.invoice.currency.code : 'CAD';
    },
    postAction(){
      return process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/invoices/"+this.invoice.id+"/files";
    },
    invoiceNumberReference : {
      set(invoiceNumberReference){this.setInvoiceNumberReference(invoiceNumberReference)},
      get(){return this.invoice.invoiceNumberReference}
    },
    invoiceDate : {
      set(date){this.setInvoiceDate(date)},
      get(){return this.invoice.date}
    },
    dueDate : {
      set(dueDate){this.setDueDate(dueDate)},
      get(){return this.invoice.dueDate}
    },
    salesRepModel : {
      set(salesRep){this.setSalesRep(salesRep)},
      get(){return this.invoice.rep;}
    },
    currencyModel: {
      set(currency) { this.setCurrency(currency) },
      get() {return this.invoice.currency; }
    },
    term : {
      set(term){this.setTerm(term)},
      get(){return this.invoice.term}
    },
    show_tierce_agency_outstanding : {
      set(show_tierce_agency_outstanding){this.setShowTierceAgencyOutstanding(show_tierce_agency_outstanding)},
      get(){return this.invoice.showTierceAgencyOutstanding}
    },
    detailedPrices : {
      set(detailedPrices){this.setShowDetailedPrices(detailedPrices)},
      get(){return this.invoice.detailedPrices}
    },
    paymentOptions : {
      set(options){
        let pt = [];
        _.forEach(options, (o) => {
          let paymentType = _.find(this.onlinePaymentMethods, t => t.id == o)
          if(paymentType != null) pt.push(paymentType);
        })
        this.setPaymentMethods(pt)
      },
      get(){
        return _.map(this.invoice.paymentTypes, p => p.id);
      }
    },
    notes : {
      set(notes){this.setNotes(notes)},
      get(){return this.invoice.notes}
    },
    editionMode(){
      return this.editInvoice!=null && this.editInvoice.id!=null;
    },
    billingAddressName(){
      return this.$t("billing_address");
    },shippingAddressName(){
      return this.$t("shipping_address");
    },
    title(){
      if(this.editionMode){
        return this.$i18n.t('invoices.invoice_dialog.title_edit');
      }else{
        return this.$i18n.t('invoices.invoice_dialog.title_new');
      }
    },
    ...mapState('invoiceEditor', ['invoice', 'customersLoading','searchedCustomers','customerContacts','terms','creditNotes','invoiceLoading','invoiceItemsLoading']),
    ...mapGetters('invoiceEditor',['canSaveDraft', 'canSaveAndSend','getInvoicePaymentOptions','customerName','canSavePaid','balanceToPay','creditNotes_credit','creditNotes_credit','creditNote_credit', 'activeCustomerContacts']),
    ...mapGetters('stockItems', [ 'allItems']),
    ...mapState('products', ['products', 'loading']),
    ...mapGetters('creditNotes',['getCreditBalance']),
    ...mapGetters('users', [ 'filterUserWithRoleRep']),
    ...mapGetters('controlData', ['getCustomGlAccounts', 'onlinePaymentMethods', 'getGlAccountsByCompanyId']),
    ...mapState('controlData', ['currencies']),
    ...mapGetters(['getCurrentPortausCompany']),
	},
  created(){
    this.fetchAdminUsers();
    this.fetchInvoiceStatuses();
    this.fetchGLAccounts();
    this.fetchCurrencies();
    this.fetchPaymentMethods();
  }
}
</script>
<style lang="scss" scoped>
@import '../../assets/scss/_variables';

.sticky {
  position: -webkit-sticky;
  position: sticky;
  top:0px;
  padding-top:20px;
  z-index:1000;
  width:100%;
  background-color:#ffffff;
}

.dialog-footer{
  position: fixed;
  display: block;
  bottom: 0px;
  width: 100%;
  background-color: #f3f7fa;
  height:50px;
  margin-left:-20px;
  padding-top:10px;
  border-top:1px solid #E4E7ED;
  z-index:100;
}

.el-input__inner{
  border:0px;
}
.title {
	font-size : 1.6em;
	font-weight:bold;

}
.product{
  line-height:20px;

  .qty{
    float:right;
    position:relative
  }
  .empty {
    color:red;
  }
}

.el-table th, .el-table td{
    vertical-align: top !important;
}

.formContainer{
    margin-left:15%;
    width:70%;
  }


@media (max-width: 1366px) {
  .formContainer{
      margin-left:10%;
      width:80%;
    }
}

@media (max-width: 1024px) {
  .formContainer{
      margin-left:2%;
      width:98%;
    }
}

</style>
